import { useInfiniteQuery } from '@tanstack/react-query'
import { documentViewsQueryOptions } from '@/entities/document'
import { Avatar } from '@/shared/ui/avatar'
import { DateStamp } from '@/shared/ui/date-stamp'
import { EmptyState } from '@/shared/ui/empty-state'
import { ZoneNote } from '@/shared/ui/zone-badge'

// Лог просмотров документа заказчиком (employee-only вкладка).
export function DocumentViewsTab({ documentId }: { documentId: string }) {
  const viewsQ = useInfiniteQuery(documentViewsQueryOptions(documentId))
  const views = viewsQ.data?.pages.flatMap((p) => p.items) ?? []

  if (views.length === 0) {
    return <EmptyState title="Просмотров нет" description="Заказчик ещё не открывал документ." />
  }

  return (
    <div className="flex flex-col gap-2">
      {/* Лог просмотров — колонка моментов: зона один раз над списком. */}
      <ZoneNote what="Время просмотра" />
      <ul className="flex flex-col gap-1.5">
        {views.map((v, i) => (
          <li
            // biome-ignore lint/suspicious/noArrayIndexKey: лог просмотров без id, порядок стабилен
            key={i}
            className="flex items-center gap-2 text-sm text-text-secondary"
          >
            <Avatar name={v.viewer.name || 'Заказчик'} size="sm" />
            <span>{v.viewer.name || 'Заказчик'}</span>
            <DateStamp value={v.viewed_at} className="text-xs text-text-tertiary" />
          </li>
        ))}
      </ul>
    </div>
  )
}
